import { render, staticRenderFns } from "./create-vehicle.vue?vue&type=template&id=65cb9e70"
import script from "./create-vehicle.vue?vue&type=script&lang=js"
export * from "./create-vehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports